/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEvent } from '../../models/calendar-event';

export interface ApiV0CalendareventCreateUpdateCalendarEventPost$Params {
      body?: CalendarEvent
}

export function apiV0CalendareventCreateUpdateCalendarEventPost(http: HttpClient, rootUrl: string, params?: ApiV0CalendareventCreateUpdateCalendarEventPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0CalendareventCreateUpdateCalendarEventPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0CalendareventCreateUpdateCalendarEventPost.PATH = '/api/v0/calendarevent/createUpdateCalendarEvent';
